import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'

import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const { data } = isSuccessResponse({ data: response })
  return {
    data:
      data?.processInstances?.map((item) => ({
        merchantId: item?.merchantConfiguration?.merchantId,
        merchantType: item?.merchantConfiguration?.merchantType,
        processingEntityID: item?.merchantConfiguration?.processingEntityID,
        txnType: item?.merchantConfiguration?.txnType,
        instrumentType: item?.merchantConfiguration?.instrumentType,
        opsMakerUserName: item?.opsMakerUser?.username,
        opsMakerActionType: item?.opsMakerActionType,
        txnMode: item?.merchantConfiguration?.txnMode,
        bankMID: item?.merchantConfiguration?.bankMID,
        mappingStatus: item?.merchantConfiguration?.mappingStatus,
        reqType: item?.merchantConfiguration?.reqType,
        pgSecurityId: item?.merchantConfiguration?.pgSecurityId,
        secret: item?.merchantConfiguration?.reqType,
        cipher: item?.merchantConfiguration?.cipher,
        merchantCfg1: item?.merchantConfiguration?.merchantCfg1,
        merchantCfg2: item?.merchantConfiguration?.merchantCfg2,
        emiCode: item?.merchantConfiguration?.emiCode,
        terminalId: item?.merchantConfiguration?.terminalId,
        ...item,
      })) ?? [],
    pagination: {
      size: data?.pageSize,
      totalElements: data?.totalItems ?? 0,
      number: data?.pageNumber + 1,
      totalPages: Math.ceil(data?.totalItems / data?.pageSize),
    },
  }
}

const getMerchantMappingApprovalApi = (data: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getMerchantMappingApproval),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: getReqBody(data),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

const getReqBody = (data: any) => {
  return {
    pageNumber: RootStore.pagination?.number - 1,
    pageSize: 10,
    ...data,
  }
}

export { getMerchantMappingApprovalApi }
